<div class="container py-5">
  @if (loading()) {
    <div class="text-center">
      <div
        class="spinner-border"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <span class="visually-hidden">{{
          'meetingResponse.loading' | translate
        }}</span>
      </div>
      <p class="mt-3">{{ 'meetingResponse.processing' | translate }}</p>
    </div>
  } @else {
    @if (status() === 'ok') {
      <div class="alert alert-success">{{ 'meetingResponse.ok' | translate }}</div>
    } @else if (status() === 'expired') {
      <div class="alert alert-warning">
        {{ 'meetingResponse.expired' | translate }}
      </div>
    } @else {
      <div class="alert alert-danger">
        {{ 'meetingResponse.invalid' | translate }}
      </div>
    }
  }
</div>
